const defaultState = {
  webUrl: false,
  viewerWebUrl: false,
  viewerBranch: false
};

const webUrlReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_VIEWER_WEB_URL": {
      return {
        ...state,
        viewerWebUrl: action.data
      };
    }
    case "SET_WEB_URL": {
      console.log("SET_WEB_URL", action);
      return {
        ...state,
        webUrl: action.data
      };
    }
    default:
      return state;
  }
};

export default webUrlReducer;
